import React, { useRef, useEffect } from "react";
import { Box } from "@mui/material";
import { MatchMessage } from "./types";
import { MatchMessageBubble } from "./MatchMessageBubble";
import { TypingIndicator } from "./TypingIndicator";

interface MatchMessageListProps {
  messages: MatchMessage[];
  isTyping: boolean;
}

export const MatchMessageList: React.FC<MatchMessageListProps> = ({
  messages,
  isTyping,
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  }, [messages.length, isTyping]);

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
        px: 2,
        py: 3,
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.default",
      }}
    >
      {messages.length === 0 && !isTyping && (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "text.secondary",
            fontSize: "0.85rem",
            textAlign: "center",
            px: 3,
          }}
        >
          Agent messages will appear here after a report is generated.
        </Box>
      )}

      {messages.map((msg) => (
        <MatchMessageBubble key={msg.id} message={msg} />
      ))}

      {isTyping && <TypingIndicator />}

      <div ref={messagesEndRef} />
    </Box>
  );
};
